import { gql } from '@apollo/client';
/**
 * @fragment AssetTypeFragment
 * @since 1.0.0
 */
export const AssetTypeFragment = gql `
  fragment AssetTypeFragment on AssetType {
    id
    title
    infos
    createdAt
    updatedAt
  }
`;
